<template>
  <div>
    <pack-info :packId="packId"></pack-info>
    <v-container>
      <v-row class="och-topMargin--packInfoOffset">
        <v-col sm="12" md="8">
          <h1 class="font-weight-thin mb-2">Update Testing/Review Status</h1>

          <test-plan-form
            mode="edit"
            :packId="packId"
            :releaseNoteId="releaseNoteId"
            :serviceAreaId="serviceAreaId"
          ></test-plan-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PackInfo from "@/components/packInfo";
import TestPlanForm from "@/components/testPlanForm";

export default {
  name: "testPlanEdit",
  components: {
    PackInfo,
    TestPlanForm,
  },
  computed: {
    packId() {
      return this.$route.params.packId;
    },
    releaseNoteId() {
      return this.$route.params.releaseNoteId;
    },
    serviceAreaId() {
      return this.$route.params.serviceAreaId;
    },
  },
};
</script>
